import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';

const useStyles = makeStyles((theme) => ({
  breadcrumb: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
}));

const BreadcrumbHeader = ({ title, breadcrumbList, ...props }) => {
  const classes = useStyles();
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={8}>
        <Typography variant="h5">{title}</Typography>
        <Breadcrumbs
          className={classes.breadcrumb}
          separator={<NavigateNextIcon fontSize="small" />}
          aria-label="breadcrumb"
        >
          {breadcrumbList.map((item) => {
            if (item.to) {
              return (
                <Link
                  key={item.name}
                  onClick={
                    props.userPrompt
                      ? (e) => {
                          e.preventDefault();
                          props.setopenModal(true);
                        }
                      : undefined
                  }
                  color="inherit"
                  href={item.to}
                >
                  {item.name}
                </Link>
              );
            }
            return (
              <Typography key={item.name} color="textPrimary">
                {item.name}
              </Typography>
            );
          })}
        </Breadcrumbs>
      </Grid>
      {props.children}
    </Grid>
  );
};

export default BreadcrumbHeader;
